<template>
    <div class="home-box-nav">
        <ul class="home-box-nav-tab">
            <li class="p-pointer" @click="goPagelesson(item)" v-for="(item,index) in navData" :key="index" @mouseover="navHoverMouse(index,true)" @mouseleave="navHoverMouse(index,false)">
                <span>{{item}}</span>
                <i class="el-icon-arrow-down"></i>
            </li>
        </ul>
        <transition>
            <div class="home-box-nav-course" v-show="navHover" @mouseover="navHoverMouse(null,true)" @mouseleave="navHoverMouse(null,false)" v-if="$store.state.home.courseData.length>0">
                <dl v-for="(items,index) in 3" :key="index">
                    <dt
                    :class="{'p-pointer':index!=2}"
                    @click="allCourseClick(index)"
                    :style="setDlColor(index) && 'color:#4D8EF6'"
                    >全部</dt>
                    <dd>
                        <span
                        class="p-pointer"
                        v-for="(item,i) in courseData[index]"
                        :key="i"
                        :style="(`${index}-${i}`===courseIndex[index]) && 'color:#4D8EF6'"
                        @click="sourseListClick(index,i,item)"> 
                            {{item.name}}
                        </span>
                    </dd>
                </dl>
                <div class="triangle"></div>
            </div>
        </transition>
    </div>
</template>
<script>
import { setAllCourseData } from '@/utils'
export default {
    data(){
        return {
            navIndex:0,
            navData:['全部課程'],
            courseIndex:['','',''],
            navHover:false,
            courseData:[],
        }
    },
    created(){
        if(this.$route.name != 'homePage'){
            this.navIndex=2;
        }
        if(this.$store.state.home.courseData.length>0)this.setCourseData(this.$store.state.home.courseData)
    },
    mounted(){
    },
    watch:{
        '$store.state.home.courseData':function(v){
            this.setCourseData(v)
        },
        '$route.name':function(v){
            if (v=='homePage') {
                this.navIndex=0;
            }
        }
    },
    methods:{
        // 分类数据处理
        setCourseData(v){
            let arrData=[];
            v.forEach((item,index) => {
                let location=item.location_code.split('.').length;
                if(typeof(arrData[location-1]) != 'object'){
                    arrData[location-1]=[]
                }
                arrData[location-1].push(item)
            });
            this.courseData=arrData;
        },
        //点击分类处理
        sourseListClick(index,i,{ id , location_code , parent_id, name}){
            const courseData = setAllCourseData(this.$store.state.home.courseData);
            this.courseIndex[index]=`${index}-${i}`;
            if(index === 0){
                this.courseData.splice(index+1,1,courseData[i].childs);
                this.courseData.splice(index+2,1,this.topData(i));
                this.courseIndex[1]='';
                this.courseIndex[2]='';
            }else if(index === 1) {
                this.courseIndex[0]=`${0}-${this.getListData1(parent_id)}`;
                this.courseData.splice(1,1,courseData[this.courseIndex[0].split('-')[1]].childs)
                this.courseData.splice(index+1,1,this.getListData(id));
                this.courseIndex[2]='';
            }else if(index === 2){
                this.courseIndex[1]=`${1}-${this.getListData1(parent_id,1)}`
                this.courseIndex[0]=`${0}-${this.getListData1(location_code.split('.')[0])}`;
                this.$router.push({path:'/lessonsAll',query:{id,parent_id,title:'全部課程'}})
                this.$router.push({path:'/lessons',query:{id,parent_id,title:name}})
                this.$store.commit('setFirstBreadcrumb',2)
            }
        },
        topData(i){
            const courseData = setAllCourseData(this.$store.state.home.courseData);
            const course = [];
            courseData[i].childs.forEach((item,index)=>{
                if(item.childs && item.childs.length){
                    course.push(...item.childs)
                }
            })
            return course
        },
        getListData(id){
            let courseData=this.$store.state.home.courseData;
            let arrData=[];
            courseData.forEach((item,index)=>{
                if(item.parent_id == id) arrData.push(item);
            });
            return arrData;
        },
        getListData1(id,p=0){
            let data=0;
            this.courseData[p].forEach((item,index)=>{
                if(id === item.id) data=index;
            });
            return data;
        },
        //全部点击
        allCourseClick(index){
            if(index === 0){
                this.courseIndex[0]='';
                this.courseIndex[1]='';
                this.courseIndex[2]='';
                this.setCourseData(this.$store.state.home.courseData);
            }else if(index === 1){
                this.courseIndex[1]='';
                this.courseData.splice(2,1,this.topData(this.courseIndex[0].split('-')[1]));
            }
        },
        setDlColor(index){
            if(index === 0){
                if(this.courseIndex[0] === ''){
                    return true;
                }
            }else if(index === 1){
                if(this.courseIndex[1] === ''){
                    return true;
                }
            }else if(index === 2){
                if(this.courseIndex[2] === ''){
                    return true;
                }
            }
            return false;
        },
        goPagelesson({ id , parent_id}){
            this.$router.push({path:'/lessonsAll',query:{id,parent_id,title:'全部課程'}})
            this.$store.commit('setFirstBreadcrumb',1)
        },
        navHoverMouse(index,v){
            this.navHover=v;
        },
    }
}
</script>


<style lang="less" scoped>
.triangle{
    width: 0;
    height: 0;
    border: 8px solid;
    border-color: transparent transparent #ffffff;
    position: absolute;
    top: -16px;
    left: 310px;
}
.v-enter,.v-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}
.v-enter-active,
.v-leave-active{
    transition: all 0.2s ease;
}
@sectionCon:1200px;
.home-box-nav{
    flex: 0;
    padding-top: 14px;
    background:rgba(77,142,246,1);
    z-index: 11;
    &-tab{
        margin:0 auto;
        li{
            display: flex;
            color:#FFFFFF;
            padding-bottom: 16px;
            position: relative;
            i{
                padding-top: 5px;
                margin-left: 10px;
                font-size: 14px;
            }
        }
    }
    &-course{
        position: absolute;
        width: @sectionCon;
        left: 50%;
        margin-left: -@sectionCon/2;
        background: #FFFFFF;
        padding-left: 35px;
        box-sizing: border-box;
        border: 1px solid #EBEEF5;
        max-height: 60vh;
        overflow: auto;
        dl{
            font-size: 14px;
            margin-top: 30px;
            display: flex;
            dt{
                font-weight:bold;
                color: #333333;
                flex: 0 0 28px
            }
            dd{
                color:rgba(51,51,51,0.70);
                margin-left: 36px;
                span{
                    display: inline-block;
                    margin-bottom: 34px;
                    margin-right: 44px;
                    &:hover{
                        color:rgba(77,142,246,1);
                    }
                }
            }
        }
    }
}
</style>
